if (!customElements.get('phone-app-showcase')) {
  customElements.define('phone-app-showcase', class extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('.phone-app__tab');
      this.screens = this.querySelectorAll('.phone-app__screen');
      this.viewport = this.querySelector('.phone-app__viewport');
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick.bind(this));
      });
    }
    onTabClick(event) {
      const selectedTab = event.currentTarget;
      const selectedIndex = selectedTab.dataset.index;
      // Update tab active states
      this.tabs.forEach((tab) => {
        tab.classList.toggle('active', tab.dataset.index === selectedIndex);
      });
      // Update screen active states
      this.screens.forEach((screen) => {
        screen.classList.toggle('active', screen.dataset.index === selectedIndex);
      });
      // Reset scroll position to top when switching tabs
      if (this.viewport) {
        this.viewport.scrollTop = 0;
      }
    }
  });
}